var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEmailThick = function SvgEmailThick(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 32.726562,
    height: 22.58239,
    viewBox: "0 0 32.726562 22.58239",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0.032
    },
    id: "path89",
    d: "M -0.09375,4.6367188 A 0.29979577,0.29979577 0 0 0 -0.36328125,4.9355469 V 4.96875 5 26.919922 a 0.29979577,0.29979577 0 0 0 0.29882813,0.298828 H 32.064453 a 0.29979577,0.29979577 0 0 0 0.298828,-0.298828 V 4.9355469 A 0.29979577,0.29979577 0 0 0 32.064453,4.6367188 H -0.06445312 a 0.29979577,0.29979577 0 0 0 -0.02929688,0 z M 1.7070312,6.7070312 H 30.261719 V 7.6054688 L 16,18.683594 1.7070312,7.6054688 Z m 0,3.5449218 14.0703128,10.90625 a 0.29979577,0.29979577 0 0 0 0.136718,0.06055 c 0.242625,0.0385 0.382262,-0.100651 0.472657,-0.179688 0.09039,-0.07904 0.166863,-0.142014 0.167969,-0.142578 a 0.29979577,0.29979577 0 0 0 0.04687,-0.03125 L 30.261719,10.253906 V 25.117188 H 1.7070312 Z",
    transform: "translate(0.36328178,-4.6363607)"
  }));
};
export default SvgEmailThick;